<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <label>{{$t('artistType').toUpperCase()}}</label>
        <select class="form-control" v-model="selectArtistType" @change="changeSelect(true)">
          <option :value="null">- {{$t('type')}} -</option>
          <option v-for="type in getTypes" :value="type" :key="type.type_en">
            {{ type[`type_${currentLng}`] }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <label>{{$t('categories').toUpperCase()}}</label>
        <select class="form-control" v-model="selectArtistCategories" @change="changeSelect()">
          <option :value="null">- {{$t('category')}} -</option>
          <option v-for="cat in getSelectedCategories" :value="cat" :key="cat.name_en">
            {{ cat[`name_${currentLng}`] }}
          </option>
        </select>
      </div>
      <div class="col-md-4">
        <label>{{$t('skillsAndStyles').toUpperCase()}}</label>
        <select class="form-control" v-model="selectArtistSkill" @change="liveUpdate">
          <option :value="null">- {{$t('skillOrStyle')}} -</option>
          <option v-for="skill in getSelectedSkills" :value="skill" :key="skill.skill_en">
            {{ skill[`skill_${currentLng}`] }}
          </option>
        </select>
      </div>
    </div>

    <div v-if="!data.onlySelect" class="row">
      <div class="col-md-4"></div>
      <div class="col-md-4 text-center">
          <button type="button" class="btn btn-default btn-add btn-outline-danger btn-filter btn-filter-alt btn-filter-alt-i btn-filter-m" :disabled="!selectArtistSkill" @click="addSkill">{{$t('pr_add_type')}}</button>        
      </div>
      <div class="col-md-4"></div>
    </div>

    <div v-if="!data.onlySelect" class="row">
        <div class="col-md-12 disable-col-padding-m">
          <div class="card skills-container" v-if="data.selectedSkills && data.selectedSkills.length">
            <div class="skills-list">
              <div v-for="(skill, index) in data.selectedSkills" :key="index">
                <span v-if="!skill.deleted"> 
                  {{getSkillString(skill)}} <i class="fa fa-times fa-size2" @click="deleteSkill(skill, index)"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
    </div>
</div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: "SelectSkills",
    props: {
      data: {},
    },
    data() {
      return {
        selectArtistType: null,
        selectArtistCategories: null,
        selectArtistSkill: null,
      }
    },
    watch: {
      selectedSkill(val) {
        if(!val) return;
        if(!this.selectArtistType || !this.selectArtistType.id || this.selectArtistType.id != this.data.selectedSkill.artistType.id) {
          this.selectArtistType = this.data.selectedSkill.artistType;
        }
        if(!this.selectArtistCategories || !this.selectArtistCategories.name_en || this.selectArtistCategories.name_en != this.data.selectedSkill.categories.name_en) {
          this.selectArtistCategories = this.data.selectedSkill.categories;
        }
        if(!this.selectArtistSkill || !this.selectArtistSkill.code || this.selectArtistSkill.code != this.data.selectedSkill.skill.code) {
          this.selectArtistSkill = this.data.selectedSkill.skill;
        }
      }
    },
    computed: {
      ...mapGetters(['currentLng','getSkills','getArtistTypes']),
      selectedSkill() {
        return this.data.selectedSkill;
      },
      getSelectedSkills() {
        let allSkill = this.selectArtistCategories ? this.getSkills.filter(skill=>this.selectArtistCategories.skills.indexOf(skill.code)!=-1)
          .sort((a,b)=>a[`skill_${this.currentLng}`].localeCompare(b[`skill_${this.currentLng}`])): null
        if(allSkill) {
          let myFilter = this.data.selectedSkills.filter(s=>s.artistTypeId===this.selectArtistType.id && s.categories===this.selectArtistCategories.name_en);
          return allSkill.filter(a=>!~myFilter.findIndex(m=>m.skill===a.code))
        } else {
          return allSkill
        }
      },
      getSelectedCategories() {
        try {
          let data = JSON.parse(JSON.stringify(this.selectArtistType))
          return this.selectArtistType ? data.categories.sort((a,b)=>a[`name_${this.currentLng}`].localeCompare(b[`name_${this.currentLng}`])) : null
        } catch (error) {
          return null;
        }
      },
      getTypes() {
        try {
          let data = JSON.parse(JSON.stringify(this.getArtistTypes))
          return data.sort((a,b)=>a[`type_${this.currentLng}`].localeCompare(b[`type_${this.currentLng}`]))
        } catch (error) {
          return null;
        }
      },
    },
    methods: {
      liveUpdate() {
        this.$emit('live-update-selected-skills',{artistType: this.selectArtistType, categories: this.selectArtistCategories, skill: this.selectArtistSkill})
      },
      changeSelect(type) {
        if(type) {
          this.selectArtistCategories = null;
          this.selectArtistSkill = null;
        } else {
          if(this.selectArtistCategories) {
            if(!this.data.onlySelect) {
              let skills = this.getSelectedSkills;
              for(let i = 0, len = skills.length; i < len; i++) {
                if (skills[i].skill_en === 'Various') {
                  this.selectArtistSkill = skills[i];
                  break;
                }
              }
            } else {
              this.selectArtistSkill = null;
            }  
          } else {
            this.selectArtistSkill = null;
          }
        }
        this.liveUpdate();
      },
      addSkill() {
        this.data.selectedSkills.push({artistTypeName: this.selectArtistType.type_en, artistTypeId: this.selectArtistType.id, categories: this.selectArtistCategories.name_en, skill: this.selectArtistSkill.code})
        this.selectArtistSkill = null;
        this.$emit('changed-selected-skills',this.data.selectedSkills);
      },
      deleteSkill(skill,index) {
        this.data.selectedSkills.splice(index,1)
        this.$emit('changed-selected-skills',this.data.selectedSkills)
      },
      getSkillString(skill) {
        let aType = this.getArtistTypes.find(t=>t.id===skill.artistTypeId)
        if(aType) {
          let aCat = aType.categories.find(c=>c.name_en===skill.categories)
          if(aCat) {
            let aSkill = this.getSkills.find(s=>s.code===skill.skill)
            if(aSkill) {
              if (aSkill.skill_en === 'Various') {
                return `${aType['type_'+this.currentLng]} - ${aCat['name_'+this.currentLng]}`
              } else {
                return `${aType['type_'+this.currentLng]} - ${aCat['name_'+this.currentLng]} -  ${aSkill['skill_'+this.currentLng]}`
              }
            } else {
              console.log(`Ненайден skill артиста с code=${skill.skill}`)
            }
          } else {
            console.log(`Ненайдена категория артиста с ID=${skill.artistTypeId} name_en=${skill.categories}`)
          }
        } else {
          console.log(`Ненайден тип артиста с ID=${skill.artistTypeId}`)
        }
        return 'Error!'
      },
    },
  }
</script>

<style lang="scss" scoped>
  .btn-default.btn-add {
    color: #565656;
    background-color: white;
    border-color: #ced4da;
    width: 100% !important;
    margin-bottom: 25px;
    margin-top: 25px;
    cursor: pointer;
  }
  .btn-default.btn-add:hover {
    border-color: #565656;
  }
  .btn-default.btn-add:disabled {
    // border-color: #ced4da;
    // background-color: #e9ecef !important;
    // color: #bdbdbd;
    cursor: not-allowed !important;
    opacity: 1;
  }
  .form-control::-webkit-input-placeholder {
    color: #6c757d;
    opacity: 1
  }
  .form-control:-ms-input-placeholder,
  .form-control::-ms-input-placeholder {
      color: #6c757d;
      opacity: 1
  }
  .form-control::placeholder {
      color: #6c757d;
      opacity: 1
  }
  .un-date-picker .un-input .un-input-inside:-moz-placeholder,
  .un-date-picker .un-input .un-input-inside::-moz-placeholder,
  .form-control:-moz-placeholder,
  .form-control::-moz-placeholder,
  .form-group .un-input-inside:-moz-placeholder,
  .form-group .un-input-inside::-moz-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }
  .un-date-picker .un-input .un-input-inside::-webkit-input-placeholder,
  .form-control::-webkit-input-placeholder,
  .form-group .un-input-inside::-webkit-input-placeholder {
      color: rgb(207, 207, 207);
      opacity: 1;
      filter: alpha(opacity=100)
  }
  .un-date-picker .un-input .un-input-inside:-ms-input-placeholder,
  .form-control:-ms-input-placeholder,
  .form-group .un-input-inside:-ms-input-placeholder {
      color: #ddd;
      opacity: 1;
      filter: alpha(opacity=100)
  }
  .form-control:focus {
    border-color: #aaa !important;
  }
  .form-control {
    background-color: #fff;
    border-radius: 4px;
    font-size: .975rem;
    color: #565656;
    padding: 8px 12px;
    height: 40px;
    box-shadow: none;
  }
  .form-control:disabled {
    background-color: #e9ecef !important;
    opacity: 1;
  }
  .card label {
    font-size: 14px;
    margin-bottom: 5px;
    text-transform: uppercase;
    font-weight: 400;
    color: #828080;
    display: inline-block;
  }
  .skills-container {
    max-height: 200px;
    overflow-y: scroll;
    padding: 10px 15px 0px 15px;
    margin-bottom: 30px;
  }
  .skills-container::-webkit-scrollbar {
      width: 8px
  }
  .skills-list div {
    margin-bottom: 5px;
  }
  .fa-size2 {
    font-size: 16px;
  }
  .fa-times {
    color: rgb(221, 0, 0);
    cursor: pointer;
    float: right;
  }
  .fa-times:hover {
    color: rgb(255, 0, 0);
  }
  @media only screen and (max-width: 768px) {
    .skills-container {
      max-height: 300px;
    }
  }
</style>
